/**
 * Creates a object for every .front-main-auth-Register DOM element.
 */
common.Object.create('front.main.auth.Register', {

	/**
	 * Called when DOM is ready.
	 */
  onDOMLoad() {
    this.initGui();
	},

	/**
	 * Initializes the GUI.
	 */
	initGui() {
		// Hide all inputs
		$('form > .form-group:not(.first-input)').hide();

		//
		var formSamename = false;

		// Listen for input changes
		$('form > .form-group:not(:last-child) input').on('change', function(event) {
			if(formSamename == true) {
				// Hide current form
				$('form > .form-group.' + event.currentTarget.name + '_' + event.currentTarget.value).slideUp();
				// And uncheck all inputs
				$('form > .form-group.' + event.currentTarget.name + '_' + event.currentTarget.value + ' input:radio').each(function () {
					$(this).prop('checked', false);
				});

				// Set edit form to normal again
				formSamename = false;
			} else {
				// Hide other form
				$('form > .form-group.' + event.currentTarget.name + '_' + (event.currentTarget.value == 'ja' ? 'nee' : 'ja')).slideUp();
				// And uncheck all inputs
				$('form > .form-group.' + event.currentTarget.name + '_' + (event.currentTarget.value == 'ja' ? 'nee' : 'ja') + ' input:radio').each(function () {
					// If checkbox need to be unchecked
					if( $(this).prop('checked') ) {
						// Change form with same id
						formSamename = true;

						$(this).trigger('change');
					}

					// Uncheck checkbox
					$(this).prop('checked', false);
				});

				// Slide down next form
				$('form > .form-group.' + event.currentTarget.name + '_' + event.currentTarget.value).slideDown();
			}
		});

		$('form > .form-group:not(:last-child)')
			.find('input:checked, select option:selected')
			.trigger('change');

		if ( ($select = $('select[name="organisation_id"]')) && $select.length )
		{
			// On field change
			$select.on('change', function (event) {
				var organisation = $(this).find('option:checked').data('organisation');

				// Fill fields
				$('form')
					.find('input[name="workaddress_title"]')
					.val(organisation.name || '')
					.end()
					.find('input[name="workaddress_name"]')
					.val(organisation.address || '')
					.end()
					.find('input[name="workaddress_number"]')
					.val(organisation.number || '')
					.end()
					.find('input[name="workaddress_postal"]')
					.val(organisation.zip_code || '')
					.end()
					.find('input[name="workaddress_place"]')
					.val(organisation.city || '')
					.end()
					.find('input[name="workaddress_phone"]')
					.val(organisation.phone_number || '')
					.end()
					.find('input[name="workaddress_website"]')
					.val(organisation.website || '')
					.end();
			});
		}
  },

});
